import MavArduCopter from '@/models/mavlink/ardupilot-copter';
import MavArduVTOL from '@/models/mavlink/ardupilot-vtol';
import MavPX4Sheco from '@/models/mavlink/px4-sheco';

const MODELS = {
  // MavLink ArduPilot Copter
  '0ae6489b-7fd4-4d9d-8b47-a8c6c7e669ca': MavArduCopter,
  // MavLink ArduPilot VTOL
  '85570cb9-64ee-46b8-b612-d8b07813d5ef': MavArduVTOL,
  // MavLink PX4 Sheco
  'd212a420-d77f-4b32-baf2-0e5095393037': MavPX4Sheco,
};

export default MODELS;
